module.exports = __webpack_public_path__ + "c382f87c83694a145e506dc19355e19d.png";